export default {
  inserted(element, binding) {
    const shouldFocus = binding.value === undefined || binding.value;
    if (shouldFocus) {
      element.focus();
    }
  },
};
